import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
// ---- ride.chatPersonalReplies (D825) -----------------------------------------------------------------------------------------
export const CHAT_PERSONAL_REPLIES_KEY = 'ride.chatPersonalReplies';
export const CHAT_PERSONAL_REPLIES_BOUNDS = {
    maxCount: { min: 1, max: 20 },
    /** The chat's own body cap: a personal ready message is sent as a normal message. */
    maxLength: { min: 1, max: 500 },
};
export const DEFAULT_CHAT_PERSONAL_REPLIES = { enabled: true, maxCount: 10, maxLength: 120 };
/** An unreadable version: no personal ready messages (the Admin's stay). */
export const STRICT_CHAT_PERSONAL_REPLIES = { enabled: false, maxCount: CHAT_PERSONAL_REPLIES_BOUNDS.maxCount.min, maxLength: CHAT_PERSONAL_REPLIES_BOUNDS.maxLength.min };
export const CHAT_PERSONAL_REPLIES_POLICY_REASON_CODES = ['CHAT_PERSONAL_REPLIES_POLICY_GOVERNED', 'CHAT_PERSONAL_REPLIES_POLICY_DEFAULT', 'CHAT_PERSONAL_REPLIES_POLICY_INVALID'];
/** The stable issue of a value that is not a `ride.chatPersonalReplies` value, or undefined when it is one. */
export function chatPersonalRepliesIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['enabled', 'maxCount', 'maxLength']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    if (typeof v.enabled !== 'boolean')
        return 'INVALID_ENABLED';
    const b = CHAT_PERSONAL_REPLIES_BOUNDS;
    if (!intWithin(v.maxCount, b.maxCount.min, b.maxCount.max))
        return 'INVALID_MAX_COUNT';
    if (!intWithin(v.maxLength, b.maxLength.min, b.maxLength.max))
        return 'INVALID_MAX_LENGTH';
    return undefined;
}
export const CHAT_PERSONAL_REPLIES_SPEC = {
    key: CHAT_PERSONAL_REPLIES_KEY,
    issue: chatPersonalRepliesIssue,
    copy: (v) => ({ enabled: v.enabled, maxCount: v.maxCount, maxLength: v.maxLength }),
    defaultValue: DEFAULT_CHAT_PERSONAL_REPLIES,
    strictValue: STRICT_CHAT_PERSONAL_REPLIES,
    reasonPrefix: 'CHAT_PERSONAL_REPLIES_POLICY',
};
export const chatPersonalRepliesSetting = (input) => marketRuleSetting(CHAT_PERSONAL_REPLIES_SPEC, input);
export function resolveChatPersonalReplies(settings, marketId, at, regionCode) {
    return resolveMarketRule(CHAT_PERSONAL_REPLIES_SPEC, settings, marketId, at, regionCode);
}
// ---- ride.chatAudio (D826) ---------------------------------------------------------------------------------------------------
export const CHAT_AUDIO_KEY = 'ride.chatAudio';
export const CHAT_AUDIO_BOUNDS = {
    maxSeconds: { min: 1, max: 300 },
    maxSizeBytes: { min: 16_384, max: 10_485_760 },
    /** Never longer than the chat's own retention (the thread is purged at 180 days and takes its recordings with it). */
    retentionDays: { min: 1, max: 180 },
};
export const DEFAULT_CHAT_AUDIO = { enabled: true, maxSeconds: 60, maxSizeBytes: 2_097_152, retentionDays: 180 };
/** An unreadable version: no voice messages. */
export const STRICT_CHAT_AUDIO = {
    enabled: false,
    maxSeconds: CHAT_AUDIO_BOUNDS.maxSeconds.min,
    maxSizeBytes: CHAT_AUDIO_BOUNDS.maxSizeBytes.min,
    retentionDays: CHAT_AUDIO_BOUNDS.retentionDays.min,
};
export const CHAT_AUDIO_POLICY_REASON_CODES = ['CHAT_AUDIO_POLICY_GOVERNED', 'CHAT_AUDIO_POLICY_DEFAULT', 'CHAT_AUDIO_POLICY_INVALID'];
/** The stable issue of a value that is not a `ride.chatAudio` value, or undefined when it is one. */
export function chatAudioIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['enabled', 'maxSeconds', 'maxSizeBytes', 'retentionDays']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    if (typeof v.enabled !== 'boolean')
        return 'INVALID_ENABLED';
    const b = CHAT_AUDIO_BOUNDS;
    if (!intWithin(v.maxSeconds, b.maxSeconds.min, b.maxSeconds.max))
        return 'INVALID_MAX_SECONDS';
    if (!intWithin(v.maxSizeBytes, b.maxSizeBytes.min, b.maxSizeBytes.max))
        return 'INVALID_MAX_SIZE_BYTES';
    if (!intWithin(v.retentionDays, b.retentionDays.min, b.retentionDays.max))
        return 'INVALID_RETENTION_DAYS';
    return undefined;
}
export const CHAT_AUDIO_SPEC = {
    key: CHAT_AUDIO_KEY,
    issue: chatAudioIssue,
    copy: (v) => ({ enabled: v.enabled, maxSeconds: v.maxSeconds, maxSizeBytes: v.maxSizeBytes, retentionDays: v.retentionDays }),
    defaultValue: DEFAULT_CHAT_AUDIO,
    strictValue: STRICT_CHAT_AUDIO,
    reasonPrefix: 'CHAT_AUDIO_POLICY',
    constraintClass: 'privacy',
    // Never looser than a layer above: off if any layer is off, the shorter recording, the smaller file, the shorter retention.
    tighten: (d, e) => ({
        enabled: d.enabled && e.enabled,
        maxSeconds: Math.min(d.maxSeconds, e.maxSeconds),
        maxSizeBytes: Math.min(d.maxSizeBytes, e.maxSizeBytes),
        retentionDays: Math.min(d.retentionDays, e.retentionDays),
    }),
};
export const chatAudioSetting = (input) => marketRuleSetting(CHAT_AUDIO_SPEC, input);
export function resolveChatAudio(settings, marketId, at, regionCode) {
    return resolveMarketRule(CHAT_AUDIO_SPEC, settings, marketId, at, regionCode);
}
//# sourceMappingURL=ride-chat-media-policy.js.map